import { render, staticRenderFns } from "./UploadImagem.vue?vue&type=template&id=7f6ad7ed&"
import script from "./UploadImagem.vue?vue&type=script&lang=js&"
export * from "./UploadImagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports